import { makeStyles, Popover } from '@material-ui/core';
import { ADDITIONAL_BILLING_STATUS } from 'doc-mate-store/lib/constants/load';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useEffect, useState } from 'react';
import AdditionalBillingSelectWrapper from './AdditionalBillingSelectWrapper';
type Props = {
  cell: {
    value: [ADDITIONAL_BILLING_STATUS, number, boolean, string?];
  };
};

const AddiitonalBillingStatusSelect: React.FC<Props> = props => {
  const classes = useStyles();
  const { cell } = props;
  const {
    value: [status, loadId, isBilling, billingIssueDescription], // eslint-disable-line @typescript-eslint/no-unused-vars
  } = cell;

  const [copy, setCopy] = useState(false);

  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  useEffect(() => {
    if (copy) {
      setTimeout(() => setCopy(false), 1000);
    }
  }, [copy]);

  return (
    <>
      <AdditionalBillingSelectWrapper
        status={status}
        loadId={loadId}
        isBilling={isBilling}
        billingIssueDescription={billingIssueDescription}
      />
      <Popover
        id={`${loadId}`}
        open={copy}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <div className={classes.popUpText}>Copied</div>
      </Popover>
    </>
  );
};

const useStyles = makeStyles(() => ({
  select: {
    '& > .MuiSelect-select.MuiSelect-select': {
      backgroundColor: 'transparent',
      paddingRight: 0,
    },
  },
  popUpText: {
    fontSize: 12,
    padding: 5,
  },
}));

export default React.memo(observer(AddiitonalBillingStatusSelect));
